"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DayOfWeekUtil {
}
DayOfWeekUtil.translateDayOfWeekToString = (dayNum) => {
    switch (dayNum) {
        case 0:
            return "monday";
        case 1:
            return "tuesday";
        case 2:
            return "wednesday";
        case 3:
            return "thursday";
        case 4:
            return "friday";
        case 5:
            return "saturday";
        case 6:
            return "sunday";
    }
};
exports.default = DayOfWeekUtil;
//# sourceMappingURL=DayOfWeekUtil.js.map